import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

import LogoComponent from "../subComponents/LogoComponent";
import SocialIcons from "../subComponents/SocialIcons";
import PowerButton from "../subComponents/PowerButton";

const Box = styled.main`
  background: ${(props) => props.theme.body};
  color: ${(props) => props.theme.text};
  width: 100vw;
  min-height: 100vh;
  padding: 7rem 1.5rem 2rem;
  display: grid;
  place-items: center;
  position: relative;
`;

const Card = styled.section`
  width: min(92vw, 36rem);
  border: 2px solid ${(props) => props.theme.text};
  padding: clamp(1.25rem, 3vw, 2rem);
  text-align: center;
  backdrop-filter: blur(2px);

  h1 {
    font-size: clamp(2rem, 5vw, 3rem);
    margin-bottom: 0.5rem;
  }

  p {
    margin-bottom: 1.25rem;
  }
`;

const Actions = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.75rem;
`;

const Action = styled(Link)`
  text-decoration: none;
  border: 1px solid ${(props) => props.theme.text};
  color: ${(props) => props.theme.text};
  padding: 0.55rem 1rem;
  transition: all 0.2s ease;

  &:hover {
    background: ${(props) => props.theme.text};
    color: ${(props) => props.theme.body};
  }
`;

const NotFoundPage = () => {
  return (
    <Box>
      <LogoComponent theme="light" />
      <SocialIcons theme="light" />
      <PowerButton />

      <Card>
        <h1>404</h1>
        <p>The page you requested could not be found.</p>
        <Actions>
          <Action to="/">Go Home</Action>
          <Action to="/work">View Projects</Action>
        </Actions>
      </Card>
    </Box>
  );
};

export default NotFoundPage;
